export default __webpack_public_path__ + "static/media/begambleaware.f4c2a12b.svg";